export enum SpinnerColor {
  White = `white`,
  Blue = `blue`,
}

export enum SpinnerSize {
  Large = `large`,
  Medium = `medium`,
  Small = `small`,
}

export enum SpinnerTheme {
  Default = `default`,
  Fancy = `fancy`,
}
